import { render } from "./activityTabForEvent.vue?vue&type=template&id=6a2b9efb&scoped=true&ts=true"
import script from "./activityTabForEvent.vue?vue&type=script&lang=ts&config=true"
export * from "./activityTabForEvent.vue?vue&type=script&lang=ts&config=true"

import "./activityTabForEvent.vue?vue&type=style&index=0&id=6a2b9efb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2b9efb"]])

export default __exports__